// extracted by mini-css-extract-plugin
export var cardimg = "DogCarouselCard-module--cardimg--65ee0";
export var customborderprovider = "DogCarouselCard-module--customborderprovider--8381e";
export var details = "DogCarouselCard-module--details--5e6db";
export var dogcard = "DogCarouselCard-module--dogcard--09aa4";
export var dogcardwrapper = "DogCarouselCard-module--dogcardwrapper--82958";
export var image = "DogCarouselCard-module--image--08e66";
export var text = "DogCarouselCard-module--text--525bb";
export var title = "DogCarouselCard-module--title--ad573 headings-module--signpostHeadingXSmall--3be29";